import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { HelpScreen, HelpScreenProps } from 'shared/screens/help';

export default function Help(props: HelpScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) => seo.setTitle(t('help.title')).setDescription(t('help.description'))}
    >
      <HelpScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(HelpScreen.pageBuilder);
